import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOSchema from "@/components/feature/SEOSchema";
import HeroSection from "./components/HeroSection";
import EntranceSection from "./components/EntranceSection";
import FeaturesSection from "./components/FeaturesSection";
import TrustSection from "./components/TrustSection";
import FAQSection from "./components/FAQSection";
import { homeData } from "@/mocks/home";

export default function Home() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "17c一起草官网入口",
    url: "https://17c-yiqicao.com",
    description: "17c一起草官网入口官方直达，提供最新地址、安全登录通道及完整功能体验。",
    contactPoint: {
      "@type": "ContactPoint",
      email: "support@17c-yiqicao.com",
      contactType: "customer service",
      availableLanguage: ["Chinese"],
    },
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "17c一起草官网入口",
    url: "https://17c-yiqicao.com",
    description: "17c一起草官网入口官方直达通道",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://17c-yiqicao.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <SEOSchema schemas={[orgSchema, webSiteSchema]} />
      <Navbar />
      <main>
        <HeroSection />
        <EntranceSection
          title={homeData.entrance.title}
          subtitle={homeData.entrance.subtitle}
          cards={homeData.entrance.cards}
        />
        <FeaturesSection
          title={homeData.features.title}
          subtitle={homeData.features.subtitle}
          items={homeData.features.items}
        />
        <TrustSection
          title={homeData.trust.title}
          subtitle={homeData.trust.subtitle}
          stats={homeData.trust.stats}
        />
        <FAQSection
          title={homeData.faq.title}
          subtitle={homeData.faq.subtitle}
          items={homeData.faq.items}
        />
      </main>
      <Footer />
    </>
  );
}